import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { 
    FixedContainer, CustomContainer, ScreenTitle, FlexRow, Circle, AppSpan, 
    AbsoluteContainer, GridContainer, FlexColumn
} from "src/style";
import { IoIosArrowBack, IoIosCheckmark } from "react-icons/io";
import { ISubsidiaryCreationStages } from "src/model";

export const NewSubsidiaryLayout: React.FC<any> = ({currentScreen, children}) => {
    const navigate = useNavigate()
    const {info: {subsidiaryCreationProcess}} = useContext(AppInfoContext)
    const [process, setProcess] = useState<ISubsidiaryCreationStages>(subsidiaryCreationProcess)

    useEffect(() => {
        setProcess(subsidiaryCreationProcess)
    }, [subsidiaryCreationProcess])

    return (
        <FlexRow
            alignItems="flex-start" padding='3'
            topPadding="4" height="100" hUnit="%"
        >
            {/* <FlexRow 
                gap="2" width="auto" 
                sizeUnit="" bottomMargin='4'
            >
                <GridContainer 
                    width="4" height="4" 
                    borderColor="#5627FF"
                    radius="0.4"
                    onClick={() => navigate(-1)}
                >
                    <IoIosArrowBack color="#5627FF" fontSize='2.5rem' />
                </GridContainer>
                <CustomContainer 
                    height="4.9" 
                    width="0.1" 
                    borderColor="#E0E0E0" 
                />
                <CustomContainer width="auto" sizeUnit="">
                    <ScreenTitle 
                        color='#333333' 
                        textSize='2.4' 
                        fontWeight='700'
                    >
                        Add New Subsidiary
                    </ScreenTitle>
                    <AppSpan color="#333333">List of all Humexs Co. group subsidiaries</AppSpan>
                </CustomContainer>
            </FlexRow> */}
            {/* <FixedContainer 
                //top="19.5" 
                top='7.5' left="30"
                className="new-user-process-flow-wrapper"
            > */}
                <CustomContainer 
                    width="35"
                    height="90" hUnit="%"
                    className='new-user-process-flow'
                >
                    <ScreenTitle 
                        textSize="2" color="#111111" 
                        fontWeight="600" bottomMargin="4"
                    >
                        Add New Subsidiary
                    </ScreenTitle>
                    <CustomContainer>
                        <FlexRow gap="1.5" bottomMargin='0.5'>
                            <Circle 
                                size="2.4" 
                                borderColor={process?.details ? '#27AE60' : currentScreen === 'details' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.details ? '#27AE60' : 'transparent'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.details ? '#ffffff' : currentScreen === 'details' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'details' && !process?.details) ? '#111111' : '#ABABAB'}
                            >
                                Subsidiary details
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer 
                            height="3.6" 
                            width="0.05" 
                            leftMargin="1.3"
                            bgColor="#ABABAB" 
                            bottomMargin='0.5'
                        />
                        <FlexRow gap="1.5" bottomMargin='0.5'>
                            <Circle 
                                size="2.4" 
                                borderColor={process?.documents ? '#27AE60' : currentScreen === 'documents' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.documents ? '#27AE60' : 'transparent'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.documents ? '#ffffff' : currentScreen === 'documents' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'documents' && !process?.documents) ? '#111111' : '#ABABAB'}
                            >
                                Business documents
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer 
                            height="3.6" 
                            width="0.05" 
                            leftMargin="1.3"
                            bgColor="#ABABAB" 
                            bottomMargin='0.5'
                        />
                    </CustomContainer>
                </CustomContainer>
            {/* </FixedContainer> */}

            <CustomContainer
                leftMargin="5"
                rightMargin="5"
                width="49.9"
                className="new-user-content"
            >
                <CustomContainer
                    bottomMargin='3'
                    className='new-user-process-flow-mobile'
                >
                    <ScreenTitle 
                        textSize="2" color="#111111" 
                        fontWeight="600" bottomMargin="4"
                    >
                        Add New Subsidiary
                    </ScreenTitle>
                    <FlexRow alignItems='flex-start' justifyContent='space-between'>
                        <AbsoluteContainer 
                            width='100' sizeUnit='%' top='1.2' zIndex='1'
                        >
                            <GridContainer>
                                <CustomContainer 
                                    height="0.05"
                                    bgColor="#ABABAB" 
                                    width='73' sizeUnit='%'
                                />
                            </GridContainer>
                        </AbsoluteContainer>
                        <FlexColumn 
                            width='auto' sizeUnit='' 
                            justifyContent='center'
                            style={{zIndex: '2'}}
                        >
                            <Circle 
                                size="2.4" bottomMargin='1'
                                borderColor={process?.details ? '#27AE60' : currentScreen === 'details' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.details ? '#27AE60' : '#ffffff'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.details ? '#ffffff' : currentScreen === 'details' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'details' && !process?.details) ? '#111111' : '#ABABAB'}
                            >
                                Subsidiary details
                            </AppSpan>
                        </FlexColumn>
                        <FlexColumn 
                            width='auto' sizeUnit='' 
                            justifyContent='center'
                            style={{zIndex: '2'}}
                        >
                            <Circle 
                                size="2.4" bottomMargin='1'
                                borderColor={process?.documents ? '#27AE60' : currentScreen === 'documents' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.documents ? '#27AE60' : '#ffffff'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.documents ? '#ffffff' : currentScreen === 'documents' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'documents' && !process?.documents) ? '#111111' : '#ABABAB'}
                            >
                                Business documents
                            </AppSpan>
                        </FlexColumn>
                    </FlexRow>
                </CustomContainer>

                {children}
            </CustomContainer>
        </FlexRow>
    )
}